export default __webpack_public_path__ + "static/media/pic6.c104b1f4.jpg";